import { Link } from "react-router-dom";
import { getLatest } from "@/lib/filmData";
import { TYPE_LABEL } from "@/types/film";

const news = getLatest(6);

function formatDate(value: string) {
  const parts = value.split("-");
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export default function LatestList() {
  return (
    <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-2">
      {news.map((film) => (
        <Link
          key={film.id}
          to={`/detail/${film.id}`}
          className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:p-4"
        >
          <div className="h-[132px] w-[92px] shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={film.cover}
              alt={`${film.title} 封面`}
              title={`${film.title} - 最新影视资讯`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
                {TYPE_LABEL[film.type]}
              </span>
              <span className="text-[11px] text-foreground-400">{formatDate(film.releaseDate)}</span>
            </div>
            <h3 className="mt-2 line-clamp-1 font-heading text-base font-bold text-foreground-950">
              {film.title}
            </h3>
            <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-500 md:text-sm">
              {film.summary}
            </p>
            <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-star-line" aria-hidden="true"></i>
                {film.cast[0]}
              </span>
              <span className="flex items-center gap-1 font-medium text-accent-600">
                <i className="ri-star-fill" aria-hidden="true"></i>
                {film.rating.toFixed(1)}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}